import { Link } from 'react-router-dom';
const WebsiteTabs = (props) => {
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/landingpage"} className={props.pageName === "LANDINGPAGE" ? "nav-link active bg-primary text-white" : "nav-link"}>LANDING PAGE</Link>
                </li>
                 <li className="nav-item" role="presentation">
                    <Link to={"/templategallery"} className={props.pageName === "WEBSITETEMPLATES" ? "nav-link active bg-primary text-white" : "nav-link"}>WEBSITE TEMPLATES</Link>
                </li>
            </ul>
    );
};

export default WebsiteTabs;
